import axios from "axios";
import { useURL } from "../data/Config";
import { IIndustry } from "../types";

interface UpdateIndustryResponse {
  success: string;
  industry: IIndustry;
}

interface DeleteIndustryResponse {
  success: string;
}

export const getAllIndustriesByAdmin = async (
  searchQuery?: string
): Promise<IIndustry[]> => {
  const token = localStorage.getItem("AUTH_TOKEN");

  const response = await axios.get<IIndustry[]>(
    `${useURL}/industries/admin/get-all-industries`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        searchQuery,
      },
    }
  );

  return response.data;
};

export const updateIndustryByAdmin = async (
  id: string,
  data: { name: string }
): Promise<UpdateIndustryResponse> => {
  const token = localStorage.getItem("AUTH_TOKEN");

  const response = await axios.patch<UpdateIndustryResponse>(
    `${useURL}/industries/admin/update-industry/${id}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};

export const deleteIndustryByAdmin = async (
  id: string
): Promise<DeleteIndustryResponse> => {
  const token = localStorage.getItem("AUTH_TOKEN");

  const response = await axios.delete<DeleteIndustryResponse>(
    `${useURL}/industries/admin/delete-industry/${id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};

export const createIndustryByAdmin = async (data: { name: string }) => {
  const token = localStorage.getItem("AUTH_TOKEN");

  const response = await axios.post(
    `${useURL}/industries/admin/create-industry`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};
